import React from 'react';

export const LoadingDots: React.FC = () => {
  return (
    <div className="flex items-center gap-bg-v2-xs">
      <span className="rounded-full w-[4px] h-[4px] bg-border-primary dot-loader dot-loader-1"></span>
      <span className="rounded-full w-[4px] h-[4px] bg-border-primary dot-loader dot-loader-2"></span>
      <span className="rounded-full w-[4px] h-[4px] bg-border-primary dot-loader dot-loader-3"></span>
    </div>
  );
};
